var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"item":_vm.item,"sub-group":_vm.subGroup}})
}
var staticRenderFns = []

export { render, staticRenderFns }